import { Space } from '@billy/design-system'
import { memo } from 'react'

import { Difference } from '@modules-deprecated/bankReconciliation/types'

import { DifferenceSelector } from '../../../../../paymentReconciliationModal/elements/DifferenceSelector'
import { ExchangeRateDeviationWarning } from '../../../../../paymentReconciliationModal/elements/ExchangeRateDeviationWarning'

interface ManualPaymentInfoProps {
  isCrossCurrency: boolean
  hasManualPaymentDifference: boolean
  manualPaymentDifference: Difference
}

export const ManualPaymentInfo = memo(
  ({ isCrossCurrency, hasManualPaymentDifference, manualPaymentDifference }: ManualPaymentInfoProps) => {
    if (!isCrossCurrency) {
      return hasManualPaymentDifference && <DifferenceSelector difference={manualPaymentDifference} />
    }

    return (
      <>
        <Space size="s12" />
        <ExchangeRateDeviationWarning />
      </>
    )
  },
)
